(function($) {
  $("section .post-content a.read-more-link[data-rel^=lightcase]").lightcase({
    maxHeight: 650,
    onStart: {
      addImages: function() {}
    },
    onFinish: {
      fixHeightOnMobile: function() {
        if (isMobile) {
          var attr = $("#lightcase-case").attr("style");
          attr +=
            "height: " + $("#lightcase-overlay").height() + "px !important";
          $("#lightcase-case").attr("style", attr);
        }
      }
    }
  });

  function changePost(ev, container, postId) {
    //  remove active classes
    container.find(`.post.active, .post-picture.active`).removeClass("active");

    // add active classes to next post
    container.find(`#post-${postId}, .post-image-${postId}`).addClass("active");

    // change dots
    container
      .find(".dot.current")
      .removeClass("current")
      .parent()
      .find(`.dot-post-id-${postId}`)
      .addClass("current");

    //  update container current post id
    container.data("currentPost", parseInt(postId));

    new LazyLoad({
      elements_selector: ".yogaloft-lazy"
    })
  }

  function mapPostIdsToContainer(container) {
    const posts = container
      .find(".post-contents .post")
      .map((i, post) =>
        $(post)
          .attr("id")
          .replace("post-", "")
      )
      .toArray();
    container.data("posts", posts);
    container.data("currentPost", parseInt(posts[0]));
  }

  function createDottedNav(container) {
    const posts = container.data("posts");
    const currentPost = container.data("currentPost");
    const footer = container.find(".post-footer");
    let nav = "";

    if (posts.length > 0) {
      const dots = posts
        .map(
          id =>
            `<li data-post-id="${id}" class="dot dot-post-id-${id}"><a href="#"></a></li>`
        )
        .join("");
      nav = `<ul class="dotted-section-nav">${dots}</ul>`;
    }

    footer
      .append(nav)
      .find(`.dot-post-id-${currentPost}`)
      .addClass("current");

    footer.find(".dot a").on("click", function(ev) {
      ev.preventDefault();
      const dotPostId = parseInt(
        $(this)
          .parent()
          .data("post-id")
      );
      $(document).trigger("sectionChangePost", [container, dotPostId]);
    });
  }

  function initPostControls(container) {
    const postControls = container.find(".post-controls .controls");
    const posts = container.data("posts");

    if (postControls.length > 0) {
      postControls.on("click", function(ev) {
        ev.preventDefault();
        let nextIndex = null;
        const currentIndex = posts.indexOf(
          container.data("currentPost").toString()
        );
        nextIndex = $(this).hasClass("next")
          ? (currentIndex + 1) % posts.length
          : currentIndex > 0
          ? currentIndex - 1
          : posts.length - 1;
        $(document).trigger("sectionChangePost", [container, posts[nextIndex]]);
      });
    }
  }

  function initSections(container) {
    mapPostIdsToContainer(container);
    createDottedNav(container);
    initPostControls(container);
  }

  $(document).on("sectionChangePost", changePost);

  //  init postContainer
  const postsContainers = $(".section .post-wrapper");
  if (postsContainers.length > 0) {
    postsContainers.each((index, section) => {
      initSections($(section));
    });
  }

  //  add section dots tooltip on hover
  if ($("html.no-touchevents").length > 0 && typeof tippy !== "undefined") {
    tippy(".dot", {
      content: "...",
      flipOnUpdate: true,
      onShow(instance) {
        const postId = $(instance.reference).data("postId");
        const postText = $(`#post-${postId} h3`).text();
        instance.setContent(postText);
      },
      onHidden(instance) {
        instance.setContent("...");
      }
    });
  }
})(jQuery);
